import styled from "styled-components";

export const Intro = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: calc(80vh - 100px);
  color: ${(props) => (props.theme === "dark" ? "#fff" : "rgb(35,35,35)")};
  width:70%;
  margin:auto;
  @media screen and (max-width: 768px) {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
  }
  h1 {
    margin: 0px 0 10px;
    font-size: 2.5rem;
    font-weight: 1200;
  }
  p {
    font-family: red;
  }
  .hello{
    margin:10px 0;
    font-size:1.3rem;
  }
  .adjust {
    font-size: 1.5rem;
    margin-bottom:15px;
  }
  .home__CTA {
    width: max-content;
  }
  .home__social {
    color: rgb(109, 131, 242);
    display: flex;
    justify-content: space-between;
    font-size: 24px;
    margin:10px 0 40px;
    cursor:pointer;
    transition: all 0.2s ease 0s;
  }
  .home__social>*:hover{
    transform:scale(1.2);
  }
  .cta{
    background: linear-gradient(
      134deg
      , rgb(106, 152, 240) 0%, rgb(73, 97, 220) 99%);
          color: rgb(248, 248, 248);
          border: none;
          cursor: pointer;
          transition: all 0.2s ease 0s;
          width: auto;
          height: auto;
          font-size: 12px;
          margin: 0px;
          padding: 12px;
          border-radius: 5px;
          margin-bottom: 10px;
  }
  .cta:hover{
    transform:scale(1.1);
  }
  @media screen and (max-width: 1000px)  {
    justify-content: space-between;
    flex-direction: column;
    /* height and m-b for fixing issue
    which was hiding the "thing i love" header */
    height: fit-content;
    margin-bottom: 140px;
    h1 {
      margin: 6px 0;
      line-height: 100%;
    }
    
  }
  .home__text>.imageContainer{
    width:35vh;
    height:35vh;
    display:flex;
    justify-content: center;
    align-items: center;
    background-color:rgb(109, 131, 242);
    border-radius:50%;
  }
  .imageContainer>img{
    display:block;
    width:70%;
    border-radius:50%;
  }
`;

export const HomeWrapper = styled.section`
  margin-bottom: 140px;
  margin-top: 80px;
  .svg-rect {
    width: 40%;
    position: absolute;
    top: 50px;
    right: 0;
    z-index: -1;
  }
  @media screen and (max-width: 768px) {
    margin-top: 80px;
    .svg-rect {
      top: 0px;
      opacity: 0.8;
    }
  }
`;
